// extracted by mini-css-extract-plugin
export var container = "ProjectsSection-module--container--1q18q";
export var title = "ProjectsSection-module--title---Uho_";
export var projectsContainer = "ProjectsSection-module--projectsContainer--16jXb";